import React from 'react';
import PaymentReconciliationPanel from '../../../components/admin/PaymentReconciliationPanel';

/**
 * Payment Reconciliation admin tab. Aggregates the new Phase 3 tools:
 *   - Net confirmed revenue + breakdown (paid/pending/failed/refunded/expired)
 *   - Clean Up Pending Transactions
 *   - Send Reconciliation Email
 *   - Export CSV
 *   - Suspicious activity surfacing
 */
const AdminReconciliationTab = () => (
  <div className="max-w-5xl">
    <PaymentReconciliationPanel />
  </div>
);

export default AdminReconciliationTab;
